/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConversationThreadContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_settings" | "LocalReplyListContainer_settings" | "UserTagsContainer_settings">;
    readonly " $refType": "ConversationThreadContainer_settings";
};
export type ConversationThreadContainer_settings$data = ConversationThreadContainer_settings;
export type ConversationThreadContainer_settings$key = {
    readonly " $data"?: ConversationThreadContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationThreadContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LocalReplyListContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'bdf024c93d9a15560eb194733ee86f29';
export default node;
